export const statuses = {
    CONCEPT: 'concept',
    TESTING: 'testing',
    RECOMMENDED: 'recommended',
    RETIRED: 'retired',
};

export function hasStatus({ status }, innerStatus)  {
    return status === innerStatus;
}

export function isConcept(measure) {
    return hasStatus(measure, statuses.CONCEPT);
}

export function isTesting(measure) {
    return hasStatus(measure, statuses.TESTING);
}

export function isRecommended(measure) {
    return hasStatus(measure, statuses.RECOMMENDED);
}

export function isRetired(measure) {
    return hasStatus(measure, statuses.RETIRED);
}

export const comparisons = {
    isConcept,
    isTesting,
    isRecommended,
    isRetired,
};

export default statuses;